import { render, staticRenderFns } from "./RequestButtonBack.vue?vue&type=template&id=1ac203d2&scoped=true"
import script from "@/components/request/RequestButtonBack/RequestButtonBack.ts?vue&type=script&lang=ts&external"
export * from "@/components/request/RequestButtonBack/RequestButtonBack.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/request/RequestButtonBack/request-button-back.scss?vue&type=style&index=0&id=1ac203d2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac203d2",
  null
  
)

export default component.exports